module.exports = __webpack_public_path__ + "img/logo-long-light.70d02a5f.png";